
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"12","height":"14"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M10.444 4.563L6 8.938 1.556 4.561l.788-.776 3.1 3.057V.188h1.112v6.655L9.66 3.791l.783.772zM10 9.155h1.333v3.938H.667V9.156H2v2.625h8V9.156z"}})])
          )
        }
      }
    